import React from 'react';

/**
 * Reusable disclaimer component for displaying risk warnings across the platform.
 * 
 * This component ensures consistent messaging about the platform's informational
 * nature and the user's responsibility for their trading decisions.
 * 
 * Usage:
 *   import DisclaimerText from '../components/DisclaimerText';
 *   <DisclaimerText />
 */
const DisclaimerText = () => (
  <p className="text-xs text-gray-500 italic mt-4">
    <strong>Disclaimer:</strong> The information provided by TrendVector is for informational and educational purposes only and does not constitute financial advice. All trading and investment decisions are your own and are made at your own risk. Past performance is not indicative of future results.
  </p>
);

export default DisclaimerText;

